import { createTheme } from "@mui/material/styles";

// RideX City Brand Token System — Blue & Green Logo
// Royal Blue     #1B4ED8 — Primary Brand Color (CTA Buttons, Headers, Fleet Card)
// Electric Green #72BF20 — Secondary Accent (Logo X, Badges, Success States)
// Navy Text      #0D1B3E — Main Body Text / Deep Dark Surfaces
// Slate Gray     #4B5563 — Secondary Descriptive Text
// Ice Blue       #EFF4FF — Subtle Section Tint Background
// Crisp White    #FFFFFF — Card & Paper Surface

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1B4ED8",      // Vibrant Royal Blue — matches logo "RIDE CITY" text
      dark: "#1338A8",      // Deeper Blue for hover states
      light: "#3B6FE8",     // Lighter Blue for tints
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#72BF20",      // Electric Lime Green — matches logo X accent
      dark: "#5B9B14",
      light: "#8FD43C",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#EFF4FF",   // Soft ice-blue page background — premium feel
      paper: "#FFFFFF",
    },
    text: {
      primary: "#0D1B3E",   // Deep navy text
      secondary: "#4B5563", // Warm slate gray
    },
    divider: "#DBEAFE",     // Light blue divider
    info: {
      main: "#1B4ED8",
    },
  },
  typography: {
    fontFamily: "'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif",
    h1: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700 },
    h2: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700 },
    h3: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 },
    h4: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 },
    h5: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 },
    h6: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 },
    button: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600, textTransform: "none" },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollBehavior: "smooth",
        },
      },
    },
  },
});

export default theme;

